<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="modules">
        <template v-slot:item.active="{ item }">
          <v-checkbox
            :data-cy="'module-' + item.id + '-active'"
            :model-value="item.active"
            @change="onModuleActiveChange(item.id, $event)"
            hide-details>
          </v-checkbox>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s v-if="oldMonthlyCost !== monthlyCost">{{ oldMonthlyCost }} €</s>
          {{ monthlyCost }} €
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="saveModules">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { MODULES } from "@/utils/constants";
import { onMounted } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import { Ref } from "vue";
import { toRaw } from "vue";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();

const props = withDefaults(
  defineProps<{
    modules: number;
    userCount: number;
  }>(),
  {
    userCount: 1
  }
);

const modules: Ref<
  Array<{
    id: number;
    active: boolean;
    price: number;
    description: string;
    module: string;
  }>
> = ref([]);

const headers: any = computed(() => {
  const modules = [
    {
      title: "Modul",
      align: "start",
      sortable: false,
      key: "module",
      width: "25%"
    },
    {
      title: "Beschreibung",
      align: "start",
      sortable: false,
      key: "description",
      width: "25%"
    },
    {
      title: "Aktiv",
      key: "active",
      sortable: false,
      width: "25%"
    },
    {
      title: "Preis pro Monat",
      key: "price",
      sortable: false,
      align: "end",
      value: (item) => item.price / 100 + " €",
      width: "25%"
    }
  ];

  if (props.userCount > 1) {
    modules.push({
      title: "Preis pro Monat (Gesamt)",
      key: "price",
      sortable: false,
      align: "end",
      value: (item) => (item.price / 100) * props.userCount + " €",
      width: "25%"
    });
  }

  return modules;
});

function loadModules() {
  // loadModules
  //
  // modules.value = MODULES;
  for (const module of Object.values(MODULES)) {
    console.log(module, module.id & props.modules);
    module.active = !!(module.id & props.modules);
    modules.value.push(module);
  }
}

function saveModules() {
  // saveModules
  console.log("saveModules");
  let result = 0;
  for (const module of modules.value) {
    console.log(module.id, module.active);
    if (module.active) {
      result |= module.id;
    }
  }

  console.log(result);

  // TODO save on server
  // payment for remaining days of the month
  //
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "warning" },
    title: t(`actions.confirmation.change-licence.title`),
    content:
      t(`actions.confirmation.change-licence.content`, {
        newPrice: monthlyCost.value
      }) +
      (additionalCharge.value
        ? t(
            `actions.confirmation.change-licence.module-added`,
            additionalCharge.value
          )
        : "") +
      (modulesRemoved.value.length
        ? t(`actions.confirmation.change-licence.module-removed`, {
            removedModules: modulesRemoved.value
              .map((module) => module.module)
              .join(", ")
          })
        : ""),
    cardTextProps: { style: { "white-space": "pre-wrap" } },
    confirmationText: t(`actions.confirmation.change-licence.confirm`),
    cancellationText: t(`actions.confirmation.change-licence.cancel`)
    // confirmationButtonProps: { color: "warning" }
  }).then((confirm) => {
    if (confirm) {
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
}

const oldMonthlyCost = computed(() => {
  return Object.values(MODULES).reduce((acc, module) => {
    if (module.id & props.modules) {
      acc += Number(module.price / 100) * props.userCount;
    }
    return acc;
  }, 0);
});

const monthlyCost = computed(() => {
  return modules.value.reduce((acc, module) => {
    if (module.active) {
      acc += Number(module.price / 100) * props.userCount;
    }
    return acc;
  }, 0);
});

const modulesAdded = computed(() => {
  return modules.value
    .filter((m) => m.active && !(m.id & props.modules))
    .map((module) => toRaw(module));
});

const additionalCharge = computed(() => {
  if (modulesAdded.value.length) {
    const now = new Date();
    const monthDays = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).getDate();
    const remainingDays = monthDays - now.getDate() + 1;
    return {
      remainingDays,
      additionalPrice:
        Math.floor(
          modulesAdded.value.reduce((acc, module) => {
            acc += Number(module.price / 100) * props.userCount;
            return acc;
          }, 0) *
            (remainingDays / monthDays) *
            100
        ) / 100,
      addedModules: modulesAdded.value.map((module) => module.module).join(", ")
    };
  }
  return null;
});

const modulesRemoved = computed(() => {
  return modules.value.filter((m) => !m.active && m.id & props.modules);
});

function onModuleActiveChange(id, event) {
  const module = modules.value.find((m) => m.id === id);
  if (module) {
    module.active = event.target.checked;
  }
}

onMounted(() => {
  loadModules();
});
</script>
